import type { ComponentProps } from 'react'

import { Image } from '@adverity/design-system/components/image'

import { assetsMap, responsiveAnimations } from './generated/assets'
import type { StaticAsset } from './generated/assets'

export type { StaticAsset, RawStaticAsset } from './generated/assets'

type Props = {
    src: StaticAsset
    maxWidth?: number
} & Omit<ComponentProps<typeof Image>, 'src'>

export const staticImageUrl = (src: StaticAsset) => assetsMap[src]
const responsiveAnimationsUrl = (src: keyof typeof responsiveAnimations) => responsiveAnimations[src]

export const StaticImage = ({ alt, src, ...props }: Props) => <Image {...props} alt={alt} src={staticImageUrl(src)} />

export const ResponsiveWebpImage = ({
    src,
    ...imgProps
}: {
    src: keyof typeof responsiveAnimations
} & ComponentProps<typeof Image>) => (
    <picture>
        <source media="(min-width: 1024px)" srcSet={responsiveAnimationsUrl(src).desktop} type="image/webp" />
        <source media="(min-width: 768px)" srcSet={responsiveAnimationsUrl(src).tablet} type="image/webp" />
        <source media="(max-width: 767px)" srcSet={responsiveAnimationsUrl(src).mobile} type="image/webp" />
        <Image src={responsiveAnimationsUrl(src).static} {...imgProps} />
    </picture>
)
